<template>
  <div
    class="toastification-system"
    @click.stop.prevent
  >
    <div class="toastification-system__content">
      <div class="toastification-system__header">
        <b-img
          :src="programLogoSrc"
          height="34px"
        />
        <div class="toastification-system__header_title">
          <div class="d-flex flex-column justify-content-end mr-50">
            <span class="font-weight-bold text-right">{{ userFirstName }}</span>
            <span class="font-weight-bold">&#128075; Приветствую вас!</span>
          </div>
          <b-img
            :src="assistantSrc"
            height="34px"
          />
        </div>
      </div>
      <hr class="w-100">
      <div class="d-flex align-items-center flex-column justify-content-center">
        <div class="toastification-system__body">
          <div
            class="mb-1 toastification-system__body-title"
          >Уведомление!</div>
          <div class="mb-1 text-body toastification-system__body-text">{{ text }}</div>
          <div class="d-flex align-items-center mb-1">
            <span class="font-weight-bold text-body mr-50">Номер акта: </span>
            <app-badge
              badge-variant="light-primary"
              :badge-text="`№ ${actNumber}`"
            />
          </div>
          <div class="d-flex align-items-center flex-column">
            <primary-button
              text="Ок"
              class="w-100 mr-1"
              @click="$emit(appConstants.app.emitEvents.CLICK_TOAST)"
            />
            <primary-button
              v-if="canGoToPayment"
              :text="goToPaymentButtonText"
              class="w-100 mt-1"
              @click.stop.prevent="onGoToPaymentClick"
            />
          </div>
        </div>
        <hr class="w-100">
        <div>С уважением, ваш {{ programVersion }} ассистент! &#x1F642;</div>
      </div>
    </div>
  </div>
</template>

<script>
import { BAvatar, BImg, BLink } from 'bootstrap-vue'
import { getFirstName, getProgramVersionLogo, getProgramVersionName } from '@/composables/currentUser'
import { mixins } from '@/mixins'
import assistantSrc from '@/assets/images/icons/assistant.svg'
import PrimaryButton from '@/views/components/app-buttons/PrimaryButton.vue'
import appConstants from '@/constants/constants'
import AppBadge from '@/views/components/badge/AppBadge.vue'
import treatmentDiaryHelper from '@/views/patient_cards/create/treatmentDiary'
import { computed } from 'vue'
import router from '@/router'
import store from '@/store'

export default {
  name: 'ToastificationNewAct',
  components: { AppBadge, PrimaryButton, BImg, BAvatar, BLink },
  emits: ['click-toast'],
  props: {
    text: {
      type: String,
      required: true,
    },
    actNumber: {
      type: [Number, String],
      required: true,
    },
    paymentId: {
      type: Number,
      required: true,
    },
    paymentDate: {
      type: [Number, String],
      required: true,
    },
  },
  setup(props, { emit }) {
    const userFirstName = mixins.methods.capitalizeFirstLetter(getFirstName())
    const programLogoSrc = getProgramVersionLogo()
    const programVersion = getProgramVersionName()
    const currentPathIsCashRegister = computed(() => router.currentRoute.name === 'apps-cash-register')
    const goToPaymentButtonText = computed(
      () => `Перейти к платежу${currentPathIsCashRegister.value ? '' : ' в кассу'}`
    )
    const { canGoToPayment, goToPayment } = treatmentDiaryHelper()

    const onGoToPaymentClick = () => {
      emit(appConstants.app.emitEvents.CLICK_TOAST)
      if (currentPathIsCashRegister.value) {
        store.commit('revenue/SET_GO_TO_PAYMENT_INFO', { id: props.paymentId, date: props.paymentDate })
      } else {
        goToPayment(props.paymentId, props.paymentDate)
      }
    }

    return {
      userFirstName,
      programLogoSrc,
      programVersion,
      canGoToPayment,
      goToPaymentButtonText,

      assistantSrc,

      appConstants,

      onGoToPaymentClick,
    }
  }
}
</script>

<style lang='scss' scoped>

.toastification-system {
  display: grid;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__header_title {
    display: flex;
    justify-content: end;
    align-items: center;
    font-size: 13px;
  }

  &__content {
    display: flex;
    flex-direction: column;
  }

  &__body {
    width: 100%;
    display: grid;
  }

  &__body-title {
    margin-top: 0;
    font-size: 1.5rem;
    font-weight: inherit;
    color: #5e5873;
  }

  &__body-text {
    font-size: 13px;
    text-align: justify;
  }
}

.dark-layout {
  .toastification-system {
    &__body-title, &__body-text {
      color: #ffffff !important;
    }
  }
}

</style>
